import { FC, useMemo } from 'react'
import { Circle, Text } from '@chakra-ui/react'
import { IElementStatus } from './MatchingElement'

type Props = {
  ch: string
  status: IElementStatus
}

const CharInCircle: FC<Props> = ({ ch, status }) => {
  const bgColor = useMemo(() => {
    switch (status) {
      case IElementStatus.SELECTED:
        return 'wood.100'
      case IElementStatus.SUCCESS:
        return 'green.50'
      case IElementStatus.FAILED:
        return 'red.50'
      case IElementStatus.DEFAULT:
        return 'transparent'
    }
  }, [status])

  const color = useMemo(() => {
    switch (status) {
      case IElementStatus.SELECTED:
        return 'wood.800'
      case IElementStatus.SUCCESS:
        return 'green.800'
      case IElementStatus.FAILED:
        return 'red.700'
      case IElementStatus.DEFAULT:
        return 'black.200'
    }
  }, [status])

  const borderColor = useMemo(() => {
    switch (status) {
      case IElementStatus.SELECTED:
        return 'wood.800'
      case IElementStatus.SUCCESS:
        return 'green.800'
      case IElementStatus.FAILED:
        return 'red.700'
      case IElementStatus.DEFAULT:
        return 'black.200'
    }
  }, [status])

  return (
    <Circle borderWidth={1} borderColor={borderColor} size={'5'} bg={bgColor}>
      <Text textStyle={'tag'} color={color}>
        {ch}
      </Text>
    </Circle>
  )
}

export default CharInCircle
